// extracted by mini-css-extract-plugin
export default {"profile__avatar":"AvatarUpload_profile__avatar__Tgd3H","profile__avatar__uploader":"AvatarUpload_profile__avatar__uploader__OPv+a"};